import { z } from "zod";
import { ContentItemSchema } from "../../fragments/ContentItem";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { PagerSchema } from "../../fragments/Pager";
import { BackdropSchema } from "../../fragments/Backdrop";
import { BladeCommonSchema } from "../common";
export const ContentListBladeTypeValues = [
    "articleCardGrid",
    "articleCardCarousel",
    "featuredNewsCarousel",
    "imageCarousel",
];
export const ContentListBladeTypesSchema = z.enum(ContentListBladeTypeValues);
export const ContentListBladeTypes = ContentListBladeTypesSchema.enum;
export const ContentListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(ContentItemSchema),
    pager: PagerSchema.optional(),
});
export const ContentListBladesContractSchema = ContentListBladeSchema.extend({
    type: ContentListBladeTypesSchema,
});
export const ArticleCardGridContractSchema = ContentListBladeSchema.extend({
    type: z.literal(ContentListBladeTypes.articleCardGrid),
});
export const ArticleCardCarouselContractSchema = ContentListBladeSchema.extend({
    type: z.literal(ContentListBladeTypes.articleCardCarousel),
});
export const FeaturedNewsCarouselContractSchema = ContentListBladeSchema.extend({
    type: z.literal(ContentListBladeTypes.featuredNewsCarousel),
});
export const ImageCarouselContractSchema = ContentListBladeSchema.extend({
    type: z.literal(ContentListBladeTypes.imageCarousel),
});
//# sourceMappingURL=index.js.map